<template>
  <span
    class="text-container"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic': content.textStyle.fontItalic === 2 ? 'normal' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      verticalAlign: content.textStyle.verticalAlign || '',
    }"
  >{{ content.text }}</span>
</template>
<script>
/*
纯文本
*/
export default {
  name: "text-text",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container{
  word-wrap: break-word;
  // word-break: normal;
  word-break: break-word;
}
</style>